<template>
  <div class="mb-2">
    <label class="dtb-field-label">Lookup Mapping <span class="text-alert">*</span></label>
    <p class="dtb-hint mb-2">
      Map source values to replacement values. Values support <code class="bg-surface-dark px-1 rounded text-[11px]">{ColumnName}</code> template placeholders, e.g.
      <code class="bg-surface-dark px-1 rounded text-[11px]">({Year} YTD) Product</code>.
    </p>
    <div v-for="(entry, ei) in entries" :key="ei" class="flex items-center gap-2 mb-2">
      <input v-model="entry.key" class="dtb-input flex-1 min-w-0" placeholder="Source value" @input="emitUpdate" />
      <span class="shrink-0 text-sm text-gray-500 font-semibold">→</span>
      <input v-model="entry.value" class="dtb-input flex-1 min-w-0" placeholder="Replacement value" @input="emitUpdate" />
      <button type="button" class="dtb-icon-btn hover:!bg-alert/10 hover:!text-alert text-base w-6 h-6" @click="removeEntry(ei)">&times;</button>
    </div>
    <button type="button" class="dtb-btn-sm" @click="addEntry">+ Add mapping</button>
  </div>
</template>

<script>
export default {
  name: 'LookupEditor',
  props: {
    lookupList: { type: Object, default: () => ({}) },
  },
  data() {
    return { entries: this.toEntries(this.lookupList) };
  },
  watch: {
    lookupList: {
      deep: true,
      handler(val) {
        const current = this.toObject(this.entries);
        if (JSON.stringify(current) !== JSON.stringify(val)) {
          this.entries = this.toEntries(val);
        }
      },
    },
  },
  methods: {
    toEntries(obj) {
      if (!obj || typeof obj !== 'object') return [{ key: '', value: '' }];
      const arr = Object.entries(obj).map(([key, value]) => ({ key, value: String(value) }));
      return arr.length > 0 ? arr : [{ key: '', value: '' }];
    },
    toObject(entries) {
      const obj = {};
      entries.forEach((e) => {
        if (e.key.trim()) obj[e.key.trim()] = e.value;
      });
      return obj;
    },
    addEntry() {
      this.entries.push({ key: '', value: '' });
    },
    removeEntry(idx) {
      this.entries.splice(idx, 1);
      if (this.entries.length === 0) this.entries.push({ key: '', value: '' });
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update', this.toObject(this.entries));
    },
  },
};
</script>

<style scoped>
/* eslint-disable max-len */
.dtb-input {
  @apply block w-full py-[7px] px-2 text-[13px] border border-stroke rounded-md bg-surface-light text-gray-500 outline-none transition-all duration-150 box-border;
}
.dtb-input:focus {
  @apply border-secondary ring-2 ring-secondary/[0.18];
}
.dtb-field-label {
  @apply block font-400 text-xs text-gray-500 mb-[3px];
}
.dtb-hint {
  @apply mt-1 text-[11px] text-gray-500;
}
.dtb-icon-btn {
  @apply inline-flex items-center justify-center w-7 h-7 border-none rounded-md bg-transparent text-gray-500 cursor-pointer transition-all duration-150 p-0 shrink-0;
}
.dtb-icon-btn svg {
  @apply w-[15px] h-[15px];
}
.dtb-icon-btn:hover {
  @apply bg-surface-dark;
}
.dtb-icon-btn:disabled {
  @apply opacity-30 cursor-not-allowed;
}
.dtb-btn-sm {
  @apply inline-flex items-center gap-1 py-1 px-2 text-[11px] font-500 rounded-md bg-surface-dark text-gray-500 border border-stroke cursor-pointer transition-colors duration-150 hover:bg-off-white;
}
</style>
